import {Component, ElementRef, forwardRef, OnInit, ViewContainerRef} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {DashboardModuleButtonAction, DashboardModuleButtonActionType, DashboardModuleButtonType, DashboardModuleType} from "fello-model";
import {DashboardModuleDirective} from "../../directives/dashboard-module.directive";
import {mixinDestroyable, mixinSpinnerAndToast} from "../../../../lib";
import {NgxSpinnerService} from "ngx-spinner";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AbstractDashboardService} from "../../services";
import {PopupLeadFormComponent} from "../dialogs";

const CTABaseComponent = mixinDestroyable(
  mixinSpinnerAndToast(
    class extends DashboardModuleDirective<DashboardModuleType.CTA> {
      constructor(public spinnerService: NgxSpinnerService, public snackBar: MatSnackBar, elementRef: ElementRef) {
        super(elementRef);
      }
    }
  )
);

@Component({
  selector: "lib-cta-module",
  templateUrl: "./cta-module.component.html",
  styleUrls: ["./cta-module.component.scss"],
  providers: [
    {
      provide: DashboardModuleDirective,
      useExisting: forwardRef(() => CtaModuleComponent)
    }
  ]
})
export class CtaModuleComponent extends CTABaseComponent {
  DashboardModuleButtonType = DashboardModuleButtonType;

  constructor(
    elementRef: ElementRef,
    private dashboardService: AbstractDashboardService,
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    spinnerService: NgxSpinnerService,
    snackBar: MatSnackBar
  ) {
    super(spinnerService, snackBar, elementRef);
  }

  performCTAAction(action: DashboardModuleButtonAction): void {
    if (action.actionType === DashboardModuleButtonActionType.POPUP_LEAD_FORM) {
      this.dialog.open(PopupLeadFormComponent, {
        maxWidth: 580,
        data: {
          action
        },
        viewContainerRef: this.viewContainerRef,
        panelClass: ["mobile-bottom-sheet"]
      });
    } else {
      this.withSpinner(this.dashboardService.performCTAAction(action)).subscribe();
    }
  }
}
